import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import Image from 'components/Image';
import { getImageFromImageObject } from 'components/Image/utils';
import { dateToStringWithFormat } from 'utils/dateUtils';
import s from './TopicTile.scss';

function customOnError(e) {
  e.target.onerror = null;
  e.target.src = 'https://static.toiimg.com/photo/25581306.cms';
}

class TopicTile extends React.Component {
  constructor() {
    super();
    this.state = {
      // pause: false,
    };
  }

  getGAVal = (gaData, data) => {
    if (typeof gaData !== 'string' || !gaData) {
      return '';
    }

    let type = 'Article';
    if (
      data.hasVideo ||
      data.hasvideo ||
      data.type === 'video' ||
      data.tn === 'video'
    ) {
      type = 'Video';
    } else if (data.type === 'photostory' || data.tn === 'photostory') {
      type = 'Photo';
    }
    return gaData.replace('$type', type);
  };

  render() {
    const { data, indexVal, wrapperClassName, isFeatureshow } = this.props;
    if (!data) {
      return null;
    }
    const { imgWidth = '300' } = data;
    const { imageid = '', imagesize = '123456', imageUrl } = data;
    const { image = {} } = data;
    image.width = imgWidth;
    image.id = imageid || image.id;
    image.version = imagesize || image.version;

    const imageSrc = getImageFromImageObject(image) || imageUrl;

    return (
      <div
        className={`${s.listItem} ${
          wrapperClassName ? s[wrapperClassName] : ''
        }`}
      >
        <Link to={data.wu} data-newga={this.getGAVal(this.props.newga, data)}>
          <figure className={s.image}>
            <div className={s.content}>
              <Image
                key={data.id}
                width={imgWidth}
                src={imageSrc}
                placeHolderSrc="https://static.toiimg.com/photo/25581306.cms"
                alt=""
                lazyload={isFeatureshow || indexVal > 2}
                onError={customOnError}
              />
            </div>
            {data.tn === 'photostory' && <i className={s.photo} />}
            {data.tn === 'video' && <i className={s.video} />}
          </figure>
          <div className={s.details}>
            {data.tn === 'liveblog' && (
              <div className={`${s.liveBtn} ${s.red}`} />
            )}
            <div
              className={`${s.title} ${s.searchTitle} ${
                data.tn === 'liveblog' ? s.liveBlinker : ''
              }`}
              dangerouslySetInnerHTML={{
                __html: `<span> ${data.hl} </span>`,
              }}
            />
            <div className={s.source}>
              {`${data.ag ? `${data.ag} /` : ``}`}
              {dateToStringWithFormat(data.dl, ' MMM DD, YYYY, HH:mm [(IST)]')}
            </div>
            <p
              className={`${s.text} ${s.searchTitle}`}
              dangerouslySetInnerHTML={{
                __html: `<span> ${data.syn ? data.syn : ``} </span>`,
              }}
            />
          </div>
        </Link>
      </div>
    );
  }
}

TopicTile.propTypes = {
  data: PropTypes.shape({}),
  onClick: PropTypes.shape({}),
  wrapperClassName: PropTypes.string,
};
TopicTile.defaultProps = {
  data: {},
  onClick: () => {},
  wrapperClassName: '',
};

export default TopicTile;
